import { render, staticRenderFns } from "./PostRadius.vue?vue&type=template&id=3c1c0af1&scoped=true&"
import script from "./PostRadius.vue?vue&type=script&lang=js&"
export * from "./PostRadius.vue?vue&type=script&lang=js&"
import style0 from "./PostRadius.vue?vue&type=style&index=0&id=3c1c0af1&prod&scoped=true&lang=scss&"
import style1 from "./PostRadius.vue?vue&type=style&index=1&id=3c1c0af1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c0af1",
  null
  
)

export default component.exports